import { images } from "../../../../Assets/assetsHelper";
import "./AgeGroupDetails.css";
import { BarLoader } from "react-spinners";
import { useNavigate } from "react-router";
import { display } from "@mui/system";
import { Autocomplete, Box, Grid, Typography } from "@mui/material";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import AddReportAttributesForm from "../../../../Components/Organisms/Forms/AddReportAttributesForm/AddReportAttributesForm";
import FormModal from "../../../../Components/Molecules/FormModal/FormModal";
import DeleteForm from "../../../../Components/Molecules/DeleteForm/DeleteForm";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import Paper from "@mui/material/Paper";
import TextFieldInput from "../../../../Components/Atoms/Inputs/TextField/TextFieldInput";
import AddAwardForm from "../../../../Components/Organisms/Forms/AddAwardForm/AddAwardForm";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--primary)",
    color: theme.palette.common.white,
    padding: 8,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: 8,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function AgeGroupDetails({
  loading,
  category,
  missions,
  missionsLoading,
  attributes,
  attributesLoading,
  setAttributes,
  setGo,
  setGoMission,
  Open,
  setOpen,
  setMissions,
  missionsUrl,
  ranking,
  rankingLoading,
  setSelectedRank,
  selectedRank,
  awards,
  setAwards,
  OpenAward,
  setOpenAward,
  setGoSave,
  OpenGenetare,
  setOpenGenerate,
  addLoading,
}) {
  // console.log(ranking);
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      <FormModal
        Open={OpenAward}
        HandleClose={() => {
          setOpenAward(false);
        }}
        Form={
          <AddAwardForm
            Open={OpenAward}
            setOpen={setOpenAward}
            id={category?.id}
            setAwards={setAwards}
          />
        }
        Title={"Add New Award"}
      />
      {category && !loading ? (
        <div className="Cont">
          <div className="greyBox">
            <Grid container spacing={1}>
              {/* Basic Information Section */}
              <Grid item xs={12}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">Basic Information</h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Category Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {category?.category?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Age Group Name
                        </Typography>
                        <Typography
                          variant="h6"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          {category?.name || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Age Range Section */}
              <Grid item xs={12}>
                <Box className="missionInfoSection">
                  <div className="missionSettingsHeader">
                    <h3 className="missionSettingsTitle">Age Range</h3>
                  </div>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Min Age
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {category?.minAge || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Max Age
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {category?.maxAge || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Min Birthday
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {category?.minBirthday?.split("T")?.at(0) || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                      <Box className="missionInfoItem">
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#6b7280",
                            fontSize: "12px",
                            marginBottom: "4px",
                            fontWeight: 500,
                          }}
                        >
                          Max Birthday
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "var(--text-primary)",
                            fontWeight: 500,
                            fontSize: "15px",
                          }}
                        >
                          {category?.maxBirthday?.split("T")?.at(0) || "-"}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              {/* Actions Section */}
              {category?.canGeneratefinalReports && (
                <Grid item xs={12}>
                  <Box className="missionInfoSection">
                    <div className="missionSettingsHeader">
                      <h3 className="missionSettingsTitle">Actions</h3>
                    </div>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "8px",
                      }}
                    >
                      <PrimaryButton
                        classBtn={"center"}
                        disabled={category?.finalReportsGenerated}
                        text={
                          !addLoading ? (
                            "Generate Final Reports"
                          ) : (
                            <div className="loadingBox">
                              <BarLoader color="#fff" />
                            </div>
                          )
                        }
                        style={{
                          textTransform: "capitalize",
                          borderRadius: "5px",
                          color: "var(--text-secondary)",
                          backgroundColor: !category?.finalReportsGenerated
                            ? "var(--primary)"
                            : "#6a050550",
                          height: "40px",
                          padding: "0 15px",
                          minWidth: "100px",
                          textWrap: "noWrap",
                        }}
                        click={() => setGoSave(true)}
                      />
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </div>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <h2 style={{}}>Missions:</h2>
            <PrimaryButton
              classBtn={"center"}
              text={"Add New Mission"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--primary)",
                height: "40px",
                padding: "0 15px",
                minWidth: "100px",
                textWrap: "noWrap",
              }}
              click={() =>
                navigate(
                  `/categories/${category?.category?.id}/ageGroups/${category?.id}/add-mission`
                )
              }
            />
          </Box>
          {missions?.length && !missionsLoading ? (
            <Grid container spacing={2}>
              {missions?.map((item) => (
                <Grid item xs={12} md={6} lg={4}>
                  <Box className="missionInfoSection">
                    <div className="missionSettingsHeader">
                      <h3 className="missionSettingsTitle">{item?.name}</h3>
                    </div>
                    <Grid container spacing={1}>
                      {/* Basic Information */}
                      <Grid item xs={12} sm={6}>
                        <Box className="missionInfoItem">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#6b7280",
                              fontSize: "12px",
                              marginBottom: "4px",
                              fontWeight: 500,
                            }}
                          >
                            Mission Order
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{
                              color: "var(--text-primary)",
                              fontWeight: 600,
                              fontSize: "18px",
                            }}
                          >
                            {item?.order || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box className="missionInfoItem">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#6b7280",
                              fontSize: "12px",
                              marginBottom: "4px",
                              fontWeight: 500,
                            }}
                          >
                            Mission Type
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{
                              color: "var(--text-primary)",
                              fontWeight: 600,
                              fontSize: "18px",
                              textTransform: "uppercase",
                            }}
                          >
                            {item?.taskType || "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      {/* Dates & Times */}
                      <Grid item xs={12}>
                        <Box className="missionInfoItem">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#6b7280",
                              fontSize: "12px",
                              marginBottom: "4px",
                              fontWeight: 500,
                            }}
                          >
                            Mission Date & Time
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "var(--text-primary)",
                              fontWeight: 500,
                              fontSize: "15px",
                            }}
                          >
                            {item?.dateTime
                              ? `${new Date(
                                  item?.dateTime
                                ).toDateString()} - ${new Date(
                                  item?.dateTime
                                ).toLocaleTimeString()}`
                              : "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box className="missionInfoItem">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#6b7280",
                              fontSize: "12px",
                              marginBottom: "4px",
                              fontWeight: 500,
                            }}
                          >
                            Submission Start
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "var(--text-primary)",
                              fontWeight: 500,
                              fontSize: "15px",
                            }}
                          >
                            {item?.submissionStartDateTime
                              ? `${new Date(
                                  item?.submissionStartDateTime
                                ).toDateString()} - ${new Date(
                                  item?.submissionStartDateTime
                                ).toLocaleTimeString()}`
                              : "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box className="missionInfoItem">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#6b7280",
                              fontSize: "12px",
                              marginBottom: "4px",
                              fontWeight: 500,
                            }}
                          >
                            Submission End
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "var(--text-primary)",
                              fontWeight: 500,
                              fontSize: "15px",
                            }}
                          >
                            {item?.submissionEndDateTime
                              ? `${new Date(
                                  item?.submissionEndDateTime
                                ).toDateString()} - ${new Date(
                                  item?.submissionEndDateTime
                                ).toLocaleTimeString()}`
                              : "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      {/* Status */}
                      <Grid item xs={12} sm={6}>
                        <Box className="missionInfoItem">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#6b7280",
                              fontSize: "12px",
                              marginBottom: "4px",
                              fontWeight: 500,
                            }}
                          >
                            Submission Status
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "var(--text-primary)",
                              fontWeight: 600,
                              fontSize: "15px",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.submissionStatus || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Box className="missionInfoItem">
                          <Typography
                            variant="body2"
                            sx={{
                              color: "#6b7280",
                              fontSize: "12px",
                              marginBottom: "4px",
                              fontWeight: 500,
                            }}
                          >
                            Judging Status
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "var(--text-primary)",
                              fontWeight: 600,
                              fontSize: "15px",
                              textTransform: "capitalize",
                            }}
                          >
                            {item?.judgingStatus || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>

                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "12px",
                      }}
                    >
                      <PrimaryButton
                        classBtn={"center"}
                        text={"See More"}
                        style={{
                          textTransform: "capitalize",
                          borderRadius: "5px",
                          color: "var(--text-secondary)",
                          backgroundColor: "var(--primary)",
                          height: "35px",
                          padding: "0 10px",
                          minWidth: "100px",
                          textWrap: "noWrap",
                        }}
                        click={() => navigate(`/missions/${item?.id}`)}
                      />
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <div>
              <h4 style={{ textAlign: "center" }}>No Missions Added Yet..</h4>
            </div>
          )}
          {/* <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          >
            <h2 style={{ margin: "" }}>Report Attributes:</h2>
            {category?.report ? (
              <DeleteForm
                setGo={setGo}
                text={"Delete Report Attributes"}
                title={"Are you sure to delete those report attributes ?"}
              />
            ) : (
              <PrimaryButton
                classBtn={"center"}
                text={"Add Report Attributes"}
                style={{
                  textTransform: "capitalize",
                  borderRadius: "5px",
                  color: "var(--text-secondary)",
                  backgroundColor: "var(--primary)",
                  height: "40px",
                  padding: "0 15px",
                  minWidth: "100px",
                  textWrap: "noWrap",
                }}
                click={() => setOpen(true)}
              />
            )}
          </Box>

          {category?.report ? (
            attributes && !attributesLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                {attributes?.groups?.map((group, i) => (
                  <Box
                    className="greyBoxWhite"
                    sx={{ width: { xs: "100%", md: "32.8%" } }}
                  >
                    <div className="greyNumberBox">
                      <div>
                        <h4>{i + 1} - Group Name: </h4>
                        <h3>{group?.name}</h3>
                      </div>
                    </div>
                    {group?.attributes?.map((att, a) => (
                      <>
                        <div className="greyNumberBox">
                          <div>
                            <h3 style={{ fontWeight: "500" }}>
                              {a + 1} - {att?.name}
                            </h3>
                          </div>
                        </div>
                        <Box
                          sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0 15px 15px",
                            borderBottom: "1px solid black",
                          }}
                        >
                          <h4>Min Value: 1</h4>
                          <h4>Max Value: {att?.maxValue}</h4>
                        </Box>
                      </>
                    ))}
                  </Box>
                ))}
              </Box>
            ) : (
              <div className="loadingBox">
                <BarLoader color="var(--primary)" />
              </div>
            )
          ) : (
            <div>
              <h4 style={{ textAlign: "center" }}>No Attributes Added Yet..</h4>
            </div>
          )} */}

          {/* <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <h2 style={{ margin: "0 20px 0 0" }}>Special Awards:</h2>
            <PrimaryButton
              classBtn={"center"}
              text={"Add New Award"}
              style={{
                textTransform: "capitalize",
                borderRadius: "5px",
                color: "var(--text-secondary)",
                backgroundColor: "var(--primary)",
                height: "40px",
                padding: "0 15px",
                minWidth: "100px",
                textWrap: "noWrap",
              }}
              click={() => setOpenAward(true)}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              flexWrap: "wrap",
              cursor: "pointer",
            }}
          >
            {awards?.map((item) => (
              <Box
                className="greyBoxWhite"
                sx={{
                  marginRight: { xs: "0", md: "20px" },
                  width: { xs: "100%", md: "auto" },
                }}
              >
                <div className="greyNumberBox">
                  <div>
                    <h4>Award's Name: </h4>
                    <h3>{item?.award}</h3>
                  </div>
                </div>
              </Box>
            ))}
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0px",
            }}
          >
            <h2>Special Awards Ranking:</h2>
            <Autocomplete
              sx={{ minWidth: "300px" }}
              options={ranking ?? []}
              getOptionLabel={(option) => option?.specialAward}
              filterSelectedOptions
              name={"rank"}
              className="choose"
              value={selectedRank}
              onChange={(e, newValue) => setSelectedRank(newValue)}
              renderInput={(params) => (
                <TextFieldInput
                  {...params}
                  label="Ranking"
                  placeholder="Choose ranking"
                  className={`Input`}
                  styles={{ width: "100%" }}
                  name={"rank"}
                  Required={false}
                />
              )}
            />
          </Box>*/}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
              marginTop: "20px",
            }}
          >
            <h2 style={{}}>Ranking:</h2>
          </Box>
          {!rankingLoading ? (
            <>
              <TableContainer
                component={Paper}
                sx={{
                  marginBottom: "30px",
                }}
              >
                <Table aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell
                        align="center"
                        style={{ minWidth: "70px" }}
                      >
                        Rank
                      </StyledTableCell>
                      <StyledTableCell
                        align="start"
                        style={{ minWidth: "140px" }}
                      >
                        Name
                      </StyledTableCell>
                      <StyledTableCell
                        align="center"
                        style={{ minWidth: "70px" }}
                      >
                        Code
                      </StyledTableCell>
                      {ranking?.ranking?.at(0)?.missions?.map((mission, i) => (
                        <StyledTableCell
                          align="center"
                          style={{ minWidth: "100px" }}
                        >
                          Mission {i + 1} Score
                        </StyledTableCell>
                      ))}
                      <StyledTableCell
                        align="center"
                        style={{ minWidth: "100px" }}
                      >
                        Total Score
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {ranking?.ranking?.map((rank, i) => (
                      <StyledTableRow key={rank?.rank}>
                        <StyledTableCell align="center">
                          {i == 0 ? (
                            <MilitaryTechIcon
                              sx={{ color: "gold", marginTop: "5px" }}
                            />
                          ) : i == 1 ? (
                            <MilitaryTechIcon
                              sx={{ color: "silver", marginTop: "5px" }}
                            />
                          ) : i == 2 ? (
                            <MilitaryTechIcon
                              sx={{ color: "#CD7F32", marginTop: "5px" }}
                            />
                          ) : (
                            <>{rank?.rank}</>
                          )}
                        </StyledTableCell>
                        <StyledTableCell align="start" sx={{}}>
                          {rank?.team?.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {rank?.team?.code}
                        </StyledTableCell>
                        {rank?.missions?.map((mission) => (
                          <StyledTableCell align="center">
                            <strong>
                              {mission?.score
                                ? `${mission?.score} Points`
                                : "-"}
                            </strong>
                          </StyledTableCell>
                        ))}
                        <StyledTableCell align="center">
                          <strong>
                            {rank?.totalScore
                              ? `${rank?.totalScore} Points`
                              : "-"}
                          </strong>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            <div className="loadingBox">
              <BarLoader color="var(--primary)" />
            </div>
          )}
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="var(--primary)" />
        </div>
      )}
    </div>
  );
}

export default AgeGroupDetails;
